import React, { useState, useEffect, useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { useSelector } from 'react-redux'
import { selectUser, selectAuthToken, selectTokenData } from '../auth/authSlice'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { API_BASE_URL as BACKEND_API_URL } from '../config'

const MyResearch = () => {
  const [showModal, setShowModal] = useState(false)
  const [trials, setTrials] = useState([])
  console.log(trials, "trials23213dds");
  const [loading, setLoading] = useState(true)
  const [reportHtml, setReportHtml] = useState(null)
  const [selectedTrialId, setSelectedTrialId] = useState(null)
  const [authToken, setAuthToken] = useState(null)
  const [authToken2, setAuthToken2] = useState(null)

  const [selectedTrialForClone, setSelectedTrialForClone] = useState(null)
  const [newName, setNewName] = useState('')
  const [newDescription, setNewDescription] = useState('')
  const [cloning, setCloning] = useState(false)
  const [organizationName, setOrganizationName] = useState('')
  console.log(organizationName, "organizationName1122");
  
  // Increment the trailing number in organizationName by 1
  useEffect(() => {
    if (organizationName && organizationName.trim()) {
      const trimmed = organizationName.trim()
      // Skip if we've already processed this value
      if (trimmed === lastProcessedNameRef.current) {
        return
      }
      // Match trailing number at the end of the string
      const match = trimmed.match(/(\d+)$/)
      if (match) {
        const number = parseInt(match[1], 10)
        const incrementedNumber = number + 2
        const baseName = trimmed.slice(0, match.index)
        const newName = baseName + incrementedNumber
        lastProcessedNameRef.current = newName
        setOrganizationName(newName)
      } else {
        // No trailing number found, mark as processed
        lastProcessedNameRef.current = trimmed
      }
    }
  }, [organizationName])
  
  const [organizationDescription, setOrganizationDescription] = useState('')
  const [organizationEmail, setOrganizationEmail] = useState('')
  const [organizationPhone, setOrganizationPhone] = useState('')
  const [organizationName1, setOrganizationName1] = useState('')
  const [organizationUrl, setOrganizationUrl] = useState('')
  console.log(organizationEmail, organizationPhone, organizationUrl, "organizationName1122");
  const [traildetails, setTraildetails] = useState('')
  console.log(traildetails, "traildetails1122");

  const [saveiddata, setSaveiddata] = useState(null)
  console.log(saveiddata?.data?._id, "saveiddata112234");

  // Ref for the report content
  const reportRef = useRef()
  // Ref for tracking organization name counter
  const organizationNameCounterRef = useRef(0)
  // Ref to track last processed organizationName to prevent infinite loops
  const lastProcessedNameRef = useRef('')

  const username = localStorage.getItem("username");
  console.log(username, "username1122");

  const user = useSelector(selectUser)
  const token = useSelector(selectAuthToken)
  const tokenData = useSelector(selectTokenData)
  console.log(user, "user14454122");
  console.log(token, "token from Redux");


  // Setup react-to-print
  const handlePrintPDF = useReactToPrint({
    contentRef: reportRef,
    documentTitle: 'report',
  })

  const API_BASE_URL = 'https://s2.genetica.ai:3001/cortex/graphiti'

  const fetchAuthToken = async () => {
    try {
      const response = await fetch('https://s2.genetica.ai:3001/Cortex/Users/$login', {
        method: 'POST',
        headers: {
          'accept': 'application/json, text/plain, */*',
          'accept-language': 'en-US,en;q=0.9',
          'authorization': 'Basic ZjJhOmYyYTExMQ==',
          'content-type': 'application/json',
          'origin': 'https://s2.genetica.ai:3001',
          'priority': 'u=1, i',
          'referer': 'https://s2.genetica.ai:3001/apps/cortex/',
          'sec-ch-ua': '"Google Chrome";v="143", "Chromium";v="143", "Not A(Brand";v="24"',
          'sec-ch-ua-mobile': '?0',
          'sec-ch-ua-platform': '"Windows"',
          'sec-fetch-dest': 'empty',
          'sec-fetch-mode': 'cors',
          'sec-fetch-site': 'same-origin',
          'user-agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36'
        },
        body: JSON.stringify(["cortex"])
      });

      if (!response.ok) {
        throw new Error(`Login failed! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Login response:", data);

      // Extract token from response (adjust based on actual response structure)
      const token = data.token || data.accessToken || data;
      return token;
    } catch (err) {
      console.error('Error fetching auth token:', err);
      throw err;
    }
  };

  // Initialize: Fetch auth token first, then fetch trials
  useEffect(() => {  
    const initialize = async () => {
      try {
        setLoading(true)
        const token = await fetchAuthToken()
        setAuthToken(`Bearer ${token}`)
        setAuthToken2(token)
        console.log('Auth token fetched successfully')
      } catch (error) {
        console.error('Failed to fetch auth token:', error)
        setLoading(false)
      }
    }
    initialize()
  }, [])

  // Fetch trials whenever authToken is set
  useEffect(() => {
    if (authToken) {
      fetchTrials()
    }
  }, [authToken])

  const fetchTrials = async () => {
    try {
      setLoading(true)

      const response = await fetch(`${API_BASE_URL}/$getObjects`, {
        method: 'POST',
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify([
          {
            "published": true,
            "metadata.categories": "prelim"
          },
          [
            "name",
            "description",
            "metadata.modified",
            "metadata.categories",
            "protocol.sponsors"
            // "protocol.sponsors.name"
          ],
          [
            "metadata.modified"
          ]
        ])
      })
      const response1 = await fetch(`${API_BASE_URL}/$getReport`, {
        method: 'POST',
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify([
          // trialId?._id,
          '6985c7bab6abb068ea67de84',
          {
            "theme": "light"
          }
        ])
      })
      

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      
      // Ensure data is an array
      let trialsData = []
      if (Array.isArray(data)) {
        trialsData = data
      } else if (data && Array.isArray(data.data)) {
        trialsData = data.data
      } else if (data && typeof data === 'object') {
        // If it's an object, try to extract array from common properties
        trialsData = data.results || data.items || data.trials || []
      }
      
      setTrials(trialsData)
    } catch (error) {
      console.error('Error fetching trials:', error)
      setTrials([]) // Set to empty array on error
    } finally {
      // Always set loading to false when response is received (success or failure)
      setLoading(false)
    }
  }

  const handleFeasibilityClick = async (trialId) => {
    console.log(trialId, "trialId1122");
    try {
      setSelectedTrialId(trialId?._id)
      setTraildetails(trialId)

      // Step 1: Create token via backend API
      // try {
      //   const tokenCreateResponse = await fetch(`${BACKEND_API_URL}/api/v1/token/create`, {
      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json'
      //     },
      //     body: JSON.stringify({
      //       token_id: trialId?._id,
      //       token: authToken?.replace('Bearer ', '')
      //     })
      //   })
      //   console.log(tokenCreateResponse, "tokenCreateResponse1122");
      //   if (!tokenCreateResponse.ok) {
      //     console.error('Token creation failed:', tokenCreateResponse.status)
      //     toast.error('Failed to create token', {
      //       position: "top-right",
      //       autoClose: 3000,
      //     })
      //   } else {
      //     const tokenCreateData = await tokenCreateResponse.json()
      //     setSaveiddata(tokenCreateData)

      //     console.log('Token created successfully:', tokenCreateData)
      //     // toast.success('Token created successfully', {
      //     //   position: "top-right",
      //     //   autoClose: 2000,
      //     // })
      //   }
      // } catch (tokenError) {
      //   console.error('Error creating token:', tokenError)
      //   toast.error('Error creating token', {
      //     position: "top-right",
      //     autoClose: 3000,
      //   })
      // }

      // Step 2: Fetch the report (existing functionality)
      const response = await fetch(`${API_BASE_URL}/$getReport`, {
        method: 'POST',
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify([
          // trialId?._id,
          '6985c7bab6abb068ea67de84',
          {
            "theme": "light"
          }
        ])
      })

      const htmlContent = await response.text()
      setReportHtml(htmlContent)
    } catch (error) {
      console.error('Error fetching report:', error)
      toast.error('Error fetching report', {
        position: "top-right",
        autoClose: 3000,
      })
    }
  }

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setNewName('')
    setNewDescription('')
    setSelectedTrialForClone(null)
    setOrganizationName('')
    setOrganizationDescription('')
    setOrganizationEmail('')
    setOrganizationPhone('')
    setOrganizationUrl('')
    lastProcessedNameRef.current = ''
  }

  const handleCloneClick = () => {
    if (!selectedTrialId) {
      alert('Please select a trial first by clicking the Feasibility button')
      return
    }

    const trial = trials.find(t => t._id === selectedTrialId)
    if (trial) {
      setSelectedTrialForClone(trial)
      setNewName(trial.name)
      setNewDescription(trial.description || '')
      console.log(trial, "trialname1122");

      // Extract sponsor information and contacts
      const firstSponsor = trial.protocol?.sponsors?.[0]
      const sponsorName = trial.name || ''
      console.log(sponsorName, "sponsorName1122");
      const sponsorDescription = firstSponsor?.description || trial.description || ''

      // Extract contacts from the first sponsor
      let email = ''
      let phone = ''
      let url = ''

      if (firstSponsor?.contacts && Array.isArray(firstSponsor.contacts)) {
        firstSponsor.contacts.forEach(contact => {
          if (contact.type === 'email') {
            email = contact.value || ''
          } else if (contact.type === 'phone') {
            phone = contact.value || ''
          } else if (contact.type === 'url') {
            url = contact.value || ''
          }
        })
      }

      // Fallback to trial-level properties if contacts not found
      // Set default name with incrementing number appended (e.g., "skin cancer protocol 1", "skin cancer protocol 2", etc.)
      organizationNameCounterRef.current += 1
      const timestamp = new Date().toISOString().replace('T', ' ').slice(0, 19)
      setOrganizationName(sponsorName ? `${sponsorName} ${organizationNameCounterRef.current} ${timestamp}` : '')
      // setOrganizationDescription(sponsorDescription)
      setOrganizationEmail('')
      setOrganizationPhone('')
      setOrganizationUrl('')
      setShowModal(true)
    }
  }

  const cloneProtocol = async () => {
    // Validate all mandatory fields
    if (!organizationName.trim()) {
      toast.error('Please enter the protocol name', {
        position: "top-right",
        autoClose: 3000,
      })
      return
    }

    // if (!organizationDescription.trim()) {
    //   toast.error('Please enter the organization description', {
    //     position: "top-right",
    //     autoClose: 3000,
    //   })
    //   return
    // }

    // if (!organizationEmail.trim()) {
    //   toast.error('Please enter the organization email', {
    //     position: "top-right",
    //     autoClose: 3000,
    //   })
    //   return
    // }

    // // Basic email validation
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    // if (!emailRegex.test(organizationEmail.trim())) {
    //   toast.error('Please enter a valid email address', {
    //     position: "top-right",
    //     autoClose: 3000,
    //   })
    //   return
    // }

    // if (!organizationPhone.trim()) {
    //   toast.error('Please enter the organization phone', {
    //     position: "top-right",
    //     autoClose: 3000,
    //   })
    //   return
    // }

    // if (!organizationUrl.trim()) {
    //   toast.error('Please enter the organization URL', {
    //     position: "top-right",
    //     autoClose: 3000,
    //   })
    //   return
    // }

    // // Basic URL validation
    // try {
    //   new URL(organizationUrl.trim())
    // } catch (e) {
    //   toast.error('Please enter a valid URL', {
    //     position: "top-right",
    //     autoClose: 3000,
    //   })
    //   return
    // }

    console.log(newName, "newName1122");
    console.log(trials, "trials1122");
    console.log(traildetails?.name, organizationName, "organizationPhone1122");
    // Check if the new name matches ANY existing protocol (including the one being cloned)
    const duplicateProtocol = traildetails?.name === organizationName;
    console.log(duplicateProtocol, traildetails?.name, organizationName, "duplicateProtocol");
    if (duplicateProtocol) {
      toast.error('A protocol with this name already exists in your library. Please rename the protocol to continue cloning.', {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    try {
      setCloning(true)

      // Step 1: Clone the graph
      const cloneResponse = await fetch(`${API_BASE_URL}/$clone`, {
        method: 'POST',
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify([
          selectedTrialForClone._id,
          organizationName,
          organizationDescription,
          null,
          selectedTrialForClone.metadata?.categories?.filter(cat => cat.startsWith('protocol-')) || [],
          null
        ])
      })

      if (!cloneResponse.ok) {
        throw new Error(`Clone failed! status: ${cloneResponse.status}`)
      }

      const cloneData = await cloneResponse.json()
      console.log('Clone successful:', cloneData)

      // Extract the cloned object _id
      const clonedObjectId = cloneData._id || cloneData.data?._id || cloneData
      if (!clonedObjectId) {
        throw new Error('Failed to get cloned object ID from response')
      }

      // Step 2: Register the investigating organization info
      const setObjectResponse = await fetch(`${API_BASE_URL}/$setObject`, {
        method: 'POST',
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify([
          clonedObjectId,
          {
            "protocol.investigator": {
              "name": organizationName1.trim(),
              "description": organizationDescription.trim(),
              "contacts": [
                { type: 'email', value: organizationEmail.trim() },
                { type: 'phone', value: organizationPhone.trim() },
                { type: 'url', value: organizationUrl.trim() }
              ]
            }
          }
        ])
      })

      if (!setObjectResponse.ok) {
        throw new Error(`Failed to register organization info! status: ${setObjectResponse.status}`)
      }

      const setObjectData = await setObjectResponse.json()
      console.log('Organization info registered successfully:', setObjectData)

      toast.success('Protocol imported successfully!', {
        position: "top-right",
        autoClose: 3000,
      })

      handleCloseModal()
      fetchTrials()
    } catch (error) {
      console.error('Error importing protocol:', error)
      toast.error('Failed to import protocol. Please try again.', {
        position: "top-right",
        autoClose: 5000,
      })
    } finally {
      setCloning(false)
    }
  }

  return (
    <>
      <ToastContainer />
      <style>{`
        .Toastify__toast-container {
          z-index: 99999 !important;
        }
      `}</style>
      <div style={{
        width: '100%',
        height: '100vh',
        background: '#f8f9fa',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}>
        {/* Header */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: '20px 40px',
          background: 'white',
          borderBottom: '1px solid #e0e0e0',
          flexShrink: 0
        }}>
          <h3 style={{
            margin: 0,
            fontSize: '18px',
            fontWeight: '400',
            color: '#333',
            flex: 1
          }}>Welcome to the HealthLabs AI Advanced Network</h3>

          {/* Action Buttons */}
          {reportHtml && (
            <div style={{
              display: 'flex',
              gap: '20px',
              alignItems: 'center',
              marginRight: '22%'
            }}>
              <button
                onClick={() => {
                  // Create a new window for printing
                  const printWindow = window.open('', '_blank')
                  printWindow.document.write(reportHtml)
                  printWindow.document.close()

                  // Wait for content to load then print
                  printWindow.onload = () => {
                    printWindow.focus()
                    printWindow.print()
                    printWindow.close()
                  }
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.2s'
                }}
                title="Print"
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2">
                  <path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                  <rect x="6" y="14" width="12" height="8" />
                </svg>
              </button>
              <button
                onClick={async () => {
                  // Call the report generation API
                  const reportGenerateResponse = await fetch(`${BACKEND_API_URL}/api/v1/report/generate`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                      reportId: selectedTrialId,
                      options: {
                        theme: "light"
                      },
                      token: authToken2
                      // token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiZjJhIiwiVFRMIjo4NjQwMCwiQUNMIjpbImYyYUB1c2VyIiwiYWRtaW4uY29ydGV4QGNhdGVnb3J5IiwicG93ZXJ1c2VyLmNvcnRleEBjYXRlZ29yeSIsInVzZXIuY29ydGV4QGNhdGVnb3J5IiwicHVibGljLmNvcnRleEBjYXRlZ29yeSJdLCJjYXRlZ29yaWVzIjpbImFkbWluLmNvcnRleCIsInBvd2VydXNlci5jb3J0ZXgiLCJ1c2VyLmNvcnRleCIsInB1YmxpYy5jb3J0ZXgiXSwiaWRlbnRpZmllcnMiOltdLCJhcGlzIjpbXSwicmVzb3VyY2VzIjp7fSwiaWF0IjoxNzcwODg5NzQzLCJleHAiOjE3NzA5NzYxNDMsImlzcyI6InByb2RAaHR0cHM6Ly9zMi5nZW5ldGljYS5haTozMDAxIn0.1jqoBbEpU8E6LnDqQhFMRwkjFtNt2Q5_hoOVLXv4b3M',
                      // download: true
                      // token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiZjJhIiwiVFRMIjo4NjQwMCwiQUNMIjpbImYyYUB1c2VyIiwiYWRtaW4uY29ydGV4QGNhdGVnb3J5IiwicG93ZXJ1c2VyLmNvcnRleEBjYXRlZ29yeSIsInVzZXIuY29ydGV4QGNhdGVnb3J5IiwicHVibGljLmNvcnRleEBjYXRlZ29yeSJdLCJjYXRlZ29yaWVzIjpbImFkbWluLmNvcnRleCIsInBvd2VydXNlci5jb3J0ZXgiLCJ1c2VyLmNvcnRleCIsInB1YmxpYy5jb3J0ZXgiXSwiaWRlbnRpZmllcnMiOltdLCJhcGlzIjpbXSwicmVzb3VyY2VzIjp7fSwiaWF0IjoxNzcxNDk0NzMxLCJleHAiOjE3NzE1ODExMzEsImlzcyI6InByb2RAaHR0cHM6Ly9zMi5nZW5ldGljYS5haTozMDAxIn0.VtuWoOXcRIb61FhXxqZNFw7ULGKgqD-wVZ4LuUut2l8'
                    })
                  })

                  const reportData = await reportGenerateResponse.json()
                  console.log(reportData?.data?.base64Pdf, "reportData32423432");

                  console.log('Report generated successfully:', reportData)

                  // Download the PDF directly from base64
                  let base64Data = reportData?.data?.base64Pdf

                  // Clean the base64 string
                  // Remove data URI prefix if present
                  if (base64Data.includes(',')) {
                    base64Data = base64Data.split(',')[1]
                  }
                  // Remove whitespace and newlines
                  base64Data = base64Data.replace(/\s/g, '')

                  console.log('Cleaned base64 length:', base64Data.length)

                  const byteCharacters = atob(base64Data)
                  const byteNumbers = new Array(byteCharacters.length)
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i)
                  }
                  const byteArray = new Uint8Array(byteNumbers)
                  const blob = new Blob([byteArray], { type: 'application/pdf' })

                  // Create download link
                  const url = window.URL.createObjectURL(blob)
                  const link = document.createElement('a')
                  link.href = url
                  link.download = `${traildetails?.name || 'Report'}.pdf`
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                  window.URL.revokeObjectURL(url)

                  toast.success('PDF downloaded successfully', {
                    position: "top-right",
                    autoClose: 2000,
                  })
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.2s'
                }}
                title="Download PDF"
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
              </button>
              <button
                onClick={handleCloneClick}
                style={{
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.2s'
                }}
                title="Clone Protocol"
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2">
                  <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
                </svg>
              </button>
            </div>
          )}

          <img
            src="/nationalimage.png"
            alt="HealthLabs AI Logo"
            style={{
              height: '62px',
              width: 'auto',
              objectFit: 'contain'
            }}
          />
        </div>

        {/* Main Content Area */}
        <div style={{
          flex: 1,
          display: 'flex',
          overflow: 'hidden',
          background: '#f8f9fa',
          justifyContent: 'flex-end'
        }}>
          {/* Left Side - Report HTML */}
          {reportHtml && (
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              margin: '20px 0 20px 20px',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
              background: 'white'
            }}>
              <iframe
                srcDoc={reportHtml}
                title="Report Preview"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  background: 'white',
                  flex: 1
                }}
              />
            </div>
          )}

          {/* Hidden div for printing - react-to-print can't access iframe content */}
          {reportHtml && (
            <div
              ref={reportRef}
              style={{ display: 'none' }}
              dangerouslySetInnerHTML={{ __html: reportHtml }}
            />
          )}

          {/* Right Side - Commercial Trials Section */}
          <div style={{
            width: reportHtml ? '380px' : '420px',
            minWidth: reportHtml ? '380px' : '420px',
            padding: '0',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            // background: '#f0f0f0'
          }}>
            <h2 style={{
              margin: '0',
              padding: '30px 20px 20px',
              fontSize: '24px',
              fontWeight: '600',
              textAlign: 'center',
              color: '#1a1a1a',
              // background: '#f0f0f0'
            }}>Commercial Trials</h2>

            {loading ? (
              <div style={{
                padding: '60px 20px',
                textAlign: 'center',
                color: '#666',
                fontSize: '16px'
              }}>Loading trials...</div>
            ) : (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0',
                width: '100%',
                padding: '0 20px 20px'
              }}>
                {trials.flatMap((trial) => {
                  const sponsors = trial.protocol?.sponsors || []

                  // If no sponsors, create one card with default sponsor
                  if (sponsors.length === 0) {
                    return (
                      <div key={trial._id} style={{
                        background: 'white',
                        borderRadius: '8px',
                        padding: '25px 20px',
                        marginBottom: '20px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                      }}>
                        {/* Default Sponsor Logo - Centered */}
                        <div style={{
                          textAlign: 'center',
                          marginBottom: '15px'
                        }}>
                          <img
                            src="/cyclotek.png"
                            alt="Company Logo"
                            style={{
                              width: '140px',
                              height: 'auto',
                              objectFit: 'contain'
                            }}
                          />
                        </div>

                        {/* Default Sponsor Name - Centered */}
                        <h3 style={{
                          margin: '0 0 20px 0',
                          fontSize: '16px',
                          fontWeight: '600',
                          textAlign: 'center',
                          color: '#1a1a1a'
                        }}>
                          Commercial Trials
                        </h3>

                        {/* Trial Name - Left Aligned */}
                        <div style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          color: '#333',
                          marginBottom: '5px',
                          textAlign: 'left'
                        }}>
                          {trial.name}
                        </div>

                        {/* Trial Description - Left Aligned */}
                        <div style={{
                          fontSize: '13px',
                          color: '#666',
                          lineHeight: '1.5',
                          marginBottom: '15px',
                          textAlign: 'left'
                        }}>
                          {trial.description}
                        </div>

                        {/* Feasibility Button - Left Aligned */}
                        <button
                          onClick={() => handleFeasibilityClick(trial)}
                          style={{
                            padding: '8px 20px',
                            fontSize: '14px',
                            fontWeight: '600',
                            color: 'white',
                            background: selectedTrialId === trial._id ? '#0056b3' : '#007bff',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.background = '#0056b3'
                          }}
                          onMouseOut={(e) => {
                            e.target.style.background = selectedTrialId === trial._id ? '#0056b3' : '#007bff'
                          }}
                        >
                          Feasibility
                        </button>
                      </div>
                    )
                  }

                  // Create a separate card for each sponsor
                  return sponsors.map((sponsor, sponsorIndex) => {
                    const sponsorLogo = sponsor?.logo?.image
                    const sponsorName = sponsor?.name || 'Commercial Trials'
                    const sponsorDescription = sponsor?.description || ''

                    return (
                      <div key={`${trial._id}-${sponsorIndex}`} style={{
                        background: 'white',
                        borderRadius: '8px',
                        padding: '25px 20px',
                        marginBottom: '20px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                      }}>
                        {/* Company Logo - Centered */}
                        <div style={{
                          textAlign: 'center',
                          marginBottom: '15px'
                        }}>
                          {sponsorLogo ? (
                            <img
                              src={sponsorLogo}
                              alt={sponsorName}
                              style={{
                                width: '140px',
                                height: 'auto',
                                objectFit: 'contain'
                              }}
                            />
                          ) : (
                            <img
                              src="/cyclotek.png"
                              alt="Company Logo"
                              style={{
                                width: '140px',
                                height: 'auto',
                                objectFit: 'contain'
                              }}
                            />
                          )}
                        </div>

                        {/* Sponsor Name - Centered */}
                        <h3 style={{
                          margin: '0 0 10px 0',
                          fontSize: '16px',
                          fontWeight: '600',
                          textAlign: 'center',
                          color: '#1a1a1a'
                        }}>
                          {sponsorName}
                        </h3>

                        {/* Sponsor Description - Centered */}
                        {/* {sponsorDescription && (
                          <div style={{
                            fontSize: '12px',
                            color: '#888',
                            lineHeight: '1.4',
                            marginBottom: '20px',
                            textAlign: 'center',
                            fontStyle: 'italic'
                          }}>
                            {sponsorDescription}
                          </div>
                        )} */}

                        {/* Trial Name - Left Aligned */}
                        <div style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          color: '#333',
                          marginBottom: '5px',
                          textAlign: 'left'
                        }}>
                          {trial.name}
                        </div>

                        {/* Trial Description - Left Aligned */}
                        <div style={{
                          fontSize: '13px',
                          color: '#666',
                          lineHeight: '1.5',
                          marginBottom: '15px',
                          textAlign: 'left'
                        }}>
                          {trial.description}
                        </div>

                        {/* Feasibility Button - Left Aligned */}
                        <button
                          onClick={() => handleFeasibilityClick(trial)}
                          style={{
                            padding: '8px 20px',
                            fontSize: '14px',
                            fontWeight: '600',
                            color: 'white',
                            background: selectedTrialId === trial._id ? '#0056b3' : '#007bff',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.background = '#0056b3'
                          }}
                          onMouseOut={(e) => {
                            e.target.style.background = selectedTrialId === trial._id ? '#0056b3' : '#007bff'
                          }}
                        >
                          Feasibility
                        </button>
                      </div>
                    )
                  })
                })}
              </div>
            )}
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 10000,
              padding: '20px',
              overflow: 'auto'
            }}
            // onClick={handleCloseModal}
          >
            <div
              className="modal-content"
              style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '8px',
                width: '100%',
                maxWidth: '600px',
                minWidth: '300px',
                maxHeight: '90vh',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                overflowY: 'auto',
                overflowX: 'hidden',
                display: 'flex',
                flexDirection: 'column'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 style={{
                marginBottom: '20px',
                color: '#333',
                fontSize: '22px',
                fontWeight: '600',
                wordBreak: 'break-word',
                lineHeight: '1.3'
              }}>
                Importing Feasibility Protocol: {selectedTrialForClone?.name || ''}
                {/* Import Protocol to Your Library */}
              </h3>

              {/* <p style={{ marginBottom: '25px', color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
              
                You're about to import the following protocol into your library:
              </p> */}

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '600', fontSize: '14px' }}>
                Organization Name 
                </label>
                <input
                  type="text"
                  value={organizationName1}
                  onChange={(e) => setOrganizationName1(e.target.value)}
                  placeholder="Enter Organization Name"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '14px',
                    boxSizing: 'border-box'
                  }}
                  // autoFocus
                />
              </div>
              {/* <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '600', fontSize: '14px' }}>
                  Organization Name <span style={{ color: '#dc3545' }}>*</span>
                </label>
                <input
                  type="text"
                  value={organizationName1}
                  onChange={(e) => setOrganizationName1(e.target.value)}
                  placeholder="Enter Organization Name"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '14px',
                    boxSizing: 'border-box'
                  }}
                  autoFocus
                />
              </div> */}

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '600', fontSize: '14px' }}>
                  Description 
                  {/* <span style={{ color: '#dc3545' }}>*</span> */}
                </label>
                <textarea
                  value={organizationDescription}
                  onChange={(e) => setOrganizationDescription(e.target.value)}
                  placeholder="Enter organization description"
                  rows="4"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '14px',
                    boxSizing: 'border-box',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '600', fontSize: '14px' }}>
                  Email 
                  {/* <span style={{ color: '#dc3545' }}>*</span> */}
                </label>
                <input
                  type="email"
                  value={organizationEmail}
                  onChange={(e) => setOrganizationEmail(e.target.value)}
                  placeholder="Enter organization email"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '14px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '600', fontSize: '14px' }}>
                  Phone
                   {/* <span style={{ color: '#dc3545' }}>*</span> */}
                </label>
                <input
                  type="tel"
                  value={organizationPhone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                    setOrganizationPhone(value);
                  }}
                  placeholder="Enter organization phone"
                  maxLength={10}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '14px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ marginBottom: '25px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: '#333', fontWeight: '600', fontSize: '14px' }}>
                  URL 
                  {/* <span style={{ color: '#dc3545' }}>*</span> */}
                </label>
                <input
                  type="url"
                  value={organizationUrl}
                  onChange={(e) => setOrganizationUrl(e.target.value)}
                  placeholder="Enter organization URL"
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '14px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* <p style={{
                marginBottom: '25px',
                color: '#555',
                fontSize: '13px',
                lineHeight: '1.6',
                padding: '12px',
                backgroundColor: '#f8f9fa',
                borderRadius: '4px',
                borderLeft: '3px solid #007bff'
              }}>
                 fields marked with <span style={{ color: '#dc3545' }}>*</span> are required.
              </p> */}

              <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                flexWrap: 'wrap',
                marginTop: 'auto',
                paddingTop: '10px'
              }}>
                <button
                  onClick={handleCloseModal}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#f0f0f0',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#e0e0e0'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                >
                  Cancel
                </button>
                <button
                  onClick={cloneProtocol}
                  disabled={cloning}
                  style={{
                    padding: '10px 24px',
                    backgroundColor: cloning ? '#6c757d' : '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: cloning ? 'not-allowed' : 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'background-color 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    opacity: cloning ? 0.7 : 1
                  }}
                  onMouseOver={(e) => !cloning && (e.target.style.backgroundColor = '#0056b3')}
                  onMouseOut={(e) => !cloning && (e.target.style.backgroundColor = '#007bff')}
                >
                  {cloning && (
                    <div
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #ffffff',
                        borderTop: '2px solid transparent',
                        borderRadius: '50%',
                        animation: 'spin 0.8s linear infinite'
                      }}
                    />
                  )}
                  {cloning ? 'Importing...' : 'Continue & Import'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* CSS Animation for Spinner */}
        <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        @media (max-width: 768px) {
          .modal-content {
            padding: 20px !important;
            max-width: 100% !important;
            margin: 10px !important;
          }
        }
        @media (max-width: 480px) {
          .modal-content {
            padding: 15px !important;
          }
        }
      `}</style>
      </div>
    </>
  )
}

export default MyResearch